import React from "react";

const CloseIcon = () => (
  <svg
    version="1.2"
    xmlns="http://www.w3.org/2000/svg"
    overflow="visible"
    preserveAspectRatio="none"
    viewBox="0 0 13 12"
    height="10"
    width="11"
  >
    <g transform="translate(1 1)">
      <g fillRule="evenodd" fill="none" id="Dashboard-/-Search_1551976184984">
        <g
          fillRule="nonzero"
          fill="#FFF"
          transform="translate(-321 -220)"
          id="Dashboard---Search---Criteria-Dropdown-Selected_1551976184984"
        >
          <g transform="translate(106 187)" id="search-bar_1551976184984">
            <g id="search-field_1551976184984">
              <g transform="translate(60 25)" id="search-pill---01_1551976184984">
                <g transform="translate(155 8)" id="x_1551976184984">
                  <rect
                    height="12"
                    width="1"
                    y="-1"
                    x="5"
                    transform="rotate(-45 5.5 5)"
                    id="Rectangle_1551976184984"
                    vectorEffect="non-scaling-stroke"
                  />
                  <rect
                    height="12"
                    width="1"
                    y="-1"
                    x="5"
                    transform="rotate(45 5.5 5)"
                    id="Rectangle-Copy_1551976184984"
                    vectorEffect="non-scaling-stroke"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default CloseIcon;
